{
  document.addEventListener("DOMContentLoaded", function () {
    const MultipleSlider = () => {
      const MultipleSliders = document.querySelectorAll(".testimonailsSlider");
      MultipleSliders.forEach((slider, index) => {
        const prevArrow = slider.parentElement.querySelector(".prev");
        const nextArrow = slider.parentElement.querySelector(".next");
        new Swiper(slider, {
          direction: "horizontal",
          // loop: true,
          speed: 1000,
          //   autoplay: {
          //     delay: 1000,
          //     disableOnInteraction: false,
          //   },
          grabCursor: true,
          navigation: {
            nextEl: nextArrow,
            prevEl: prevArrow,
          },
          breakpoints: {
            150: {
              slidesPerView: 1.2,
              spaceBetween: 10,
            },
            576: {
              slidesPerView: 2.1,
              spaceBetween: 15,
            },
            769: {
              slidesPerView: 2.5,
              spaceBetween: 20,
            },
            1025: {
              slidesPerView: 3,
              spaceBetween: 20,
            },
            1200: {
              slidesPerView: 4,
              spaceBetween: 30,
            },
          },
        });
      });
    };
    MultipleSlider();
  });
}
{
  document.addEventListener("DOMContentLoaded", function () {
    const MultipleSlider = () => {
      const MultipleSliders = document.querySelectorAll(".blogs__lits");
      MultipleSliders.forEach((slider, index) => {
        const prevArrow = slider.parentElement.querySelector(".prev");
        const nextArrow = slider.parentElement.querySelector(".next");
        new Swiper(slider, {
          direction: "horizontal",
          // loop: true,
          speed: 1000,
          //   autoplay: {
          //     delay: 1000,
          //     disableOnInteraction: false,
          //   },
          grabCursor: true,
          navigation: {
            nextEl: nextArrow,
            prevEl: prevArrow,
          },
          breakpoints: {
            150: {
              slidesPerView: 1.2,
              spaceBetween: 10,
            },
            576: {
              slidesPerView: 2,
              spaceBetween: 15,
            },
            769: {
              slidesPerView: 2.6,
              spaceBetween: 20,
            },
            1025: {
              slidesPerView: 3,
              spaceBetween: 20,
            },
            1200: {
              slidesPerView: 3,
              spaceBetween: 30,
            },
          },
        });
      });
    };
    MultipleSlider();
  });
}
{
  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".rviews__lits").forEach((slider) => {
      const wrapper = slider.querySelector(".swiper-wrapper");
      const originalSlides = slider.querySelectorAll(".swiper-slide");
      const clones = parseInt(slider.dataset.cloneMultiplier, 10) || 2;
      for (let i = 0; i < clones; i++) {
        originalSlides.forEach((s) => wrapper.appendChild(s.cloneNode(true)));
      }
      const swiper = new Swiper(slider, {
        loop: true,
        grabCursor: true,
        direction: "horizontal",
        autoplay: {
          delay: 0,
          disableOnInteraction: false,
        },
        speed: 6000,
        centerSlide: true,
        breakpoints: {
          1200: {
            slidesPerView: 5,
            spaceBetween: 30,
          },
          1025: {
            slidesPerView: 3.2,
            spaceBetween: 20,
          },
          769: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          576: {
            slidesPerView: 2,
            spaceBetween: 15,
          },
          300: {
            slidesPerView: 1.5,
            spaceBetween: 10,
          },
        },
      });
    });
  });
}
